import { AxiosPromise } from 'axios';
import request from '../utils/request';
import { WhatsNewPreferences } from '../types';

function getWhatsNewContent(language: string) {
  return request({
    url: `/whatsNew/${language}`,
    method: 'GET',
  });
}

function apiGetWhatsNewPreferences(): AxiosPromise<WhatsNewPreferences> {
  return request({
    url: 'loginUser/userPreferences/whatsNew',
    method: 'GET',
  });
}

function apiUpdateWhatsNewPreferences(data: {
  whatsNewDisabled: boolean;
  olhVersion: string;
}) {
  console.log(`change user preference, payload ${JSON.stringify(data)}`);
  return request({
    url: 'loginUser/userPreferences/whatsNew',
    method: 'PUT',
    data,
  });
}

export default {
  getWhatsNewContent,
  apiGetWhatsNewPreferences,
  apiUpdateWhatsNewPreferences,
};
